<template>
    <v-row class="mb-15 fill-height">
        <v-col>
            <v-row>
                <v-col>
                    <h1>Reporte de Emisiones Auto</h1>
                </v-col>
            </v-row>
            <v-row style="padding-left: 30px; margin-top: 25px"> </v-row>
            <v-row class="mb-15" style="padding-left: 30px">
                <v-col md="3">
                    <h3>Selecciona el rango de fechas</h3>
                    <v-date-picker style="width: 100%" v-model="dates" range></v-date-picker>
                    <v-btn rounded color="primary" style="width: 100%" dark @click="consultar(false)">Consultar</v-btn>
                    <v-btn @click="consultar(true)" rounded color="primary" style="width:100%;margin-top:20px;" :disabled="bloquear">
                            Descargar Información
                    </v-btn>
                </v-col>
                <v-col cols="9" md="9">
                    <div>
                        <div v-if="loading" style="text-align: center">
                            <h2 class="pb-4">{{downloading ? 'Descargando Reporte....' : 'Cargando Reporte....'}}</h2>
                            <br /><br />
                            <md-progress-spinner :md-diameter="100" :md-stroke="10" md-mode="indeterminate" />
                        </div>
                    </div>

                    <v-data-table :headers="columns" :items="leads" item-key="name" class="elevation-1" :search="search" :server-items-length="totalRegistros" :loading="loading" loading-text="Cargando..."
                        :custom-filter="filterOnlyCapsText" :items-per-page="elementosPagina" @update:page="pagina = $event" @update:items-per-page="elementosPagina = $event">
                        <template v-slot:top>
                            <v-text-field v-model="search" label="Buscar" class="mx-4"></v-text-field>
                        </template>
                    </v-data-table>
                </v-col>
            </v-row>
        </v-col>
    </v-row>
</template>

<script>
var moment = require("moment-timezone");
import { mapState } from 'vuex';
import download from "downloadjs";

export default {
    data() {
        return {
            dates: ["", ""],
            downloading: false,
            roles: JSON.parse(localStorage.getItem("roles")),
            agenteUuid: localStorage.getItem("agenteUuid"),
            loading: false,
            reportType: "lead",
            leads: [],
            search: "",
            reportCompleteDowload: [],
            bloquear: true,
            block: true,
            canal: null,
            canales: [
                { id: 1, name: "AGENTES" },
                { id: 2, name: "MASIVOS" },
                { id: 3, name: "DIRECTOS" },
            ],

            columns: [
                { text: "Poliza", value: "polizaInterna" },
                { text: "Cliente", value: "cliente" },
                { text: "Fecha inicio vigencia", value: "fecha_inicio_vigencia" },
                { text: "Fecha fin vigencia", value: "fecha_fin_vigencia" },
                { text: "Tipo de contratante", value: "tipo_cliente" },
                { text: "Aseguradora", value: "aseguradora" },
                { text: "Plan", value: "plan" },
                { text: "Prima neta", value: "prima_neta" },
                { text: "Ejecutivo CC", value: "ejecutivo" },
            ],
            pagina: 1,
            elementosPagina: 10,
            totalRegistros: 0,
        };
    },
    watch: {
        pagina(v){
            !!v && this.consultar();
        },
        elementosPagina(v){
            !!v && this.consultar();
        },
    },

    methods: {
        convertDate(date) {
            const dateRes = moment(date);
            dateRes.tz("UTC", true);
            return dateRes.tz("America/Mexico_City").format("DD-MM-YYYY HH:mm");
        },

        async consultar(file = false) {
            this.loading = true;
            this.bloquear = true;
            this.downloading = file;
            let config = {
                headers: {
                    Authorization: "Bearer " + localStorage.agenteAccessToken,
                },
            };

            var inicioUTC = null;
            var finUTC = null;

            if (this.dates.length > 0) {
                if (this.dates[1]) {
                    inicioUTC = moment.utc(this.dates[0]).format("YYYY-MM-DD HH:mm:ss");
                    finUTC = moment
                        .utc(this.dates[1])
                        .add(24, "hours")
                        .subtract(1, "seconds")
                        .format("YYYY-MM-DD HH:mm:ss");
                } else {
                    inicioUTC = moment.utc(this.dates[0]).format("YYYY-MM-DD HH:mm:ss");
                    finUTC = moment
                        .utc(this.dates[0])
                        .add(24, "hours")
                        .subtract(1, "seconds")
                        .format("YYYY-MM-DD HH:mm:ss");
                }
            }
            let query = {
                fechas: [inicioUTC, finUTC],
                ramo: "AUTOS",
                elementosPagina: this.elementosPagina,
                pagina: this.pagina,
            };
            let route = "v1/bradescard/emisiones-ramo";
            if(file) route += "/file";
            let { data } = await this.$axios.post(route, query, config);

            if(file) return this.manageFileResponse(data);

            this.leads = [];
            this.reportCompleteDowload = [];

            if(data.length) this.totalRegistros = data[0].totalRegistros;

            data.map((element) => {

                this.leads.push({
                    uuid: element.uuid,
                    polizaInterna: element.polizaInterna
                        ? element.polizaInterna
                        : "No disponible",
                    cliente:
                        (element.nombreE ? element.nombreE : " ") +
                        " " +
                        (element.apellido_paternoE ? element.apellido_paternoE : " ") +
                        " " +
                        (element.apellido_maternoE ? element.apellido_maternoE : " "),
                    fecha_inicio_vigencia: element.inicio
                        ? moment
                            .utc(element.inicio)
                            .subtract(6, "hours")
                            .format("DD/MM/YYYY HH:mm:ss")
                        : "No Disponible",
                    fecha_fin_vigencia: element.fin
                        ? moment
                            .utc(element.fin)
                            .subtract(6, "hours")
                            .format("DD/MM/YYYY HH:mm:ss")
                        : "No Disponible",
                    tipo_cliente: element.tipo_cliente
                        ? element.tipo_cliente
                        : "No disponible",
                    aseguradora: element.aseguradora ? element.aseguradora : "No disponible",
                    plan: element.plan
                        ? element.plan
                        : "No disponible",
                    prima_neta: element.prima_neta
                        ? this.toCurrency(element.prima_neta)
                        : "No disponible",
                    ejecutivo: element.ejecutivo ? element.ejecutivo : "No disponible",
                });
            });
            this.bloquear = (Array.isArray(this.leads) && this.leads.length === 0) ? true : false;
            this.loading = false;
        },
        manageFileResponse(responseData) {
            download(
                responseData,
                `Reporte_Emisiones_Autos.csv`,
                "application/csv"
            );
            this.bloquear = (Array.isArray(this.leads) && this.leads.length === 0) ? true : false;
            this.loading = false;
        },
        toCurrency(number) {
            var formatter = new Intl.NumberFormat("en-US", {
                style: "currency",
                currency: "USD",
            });
            return formatter.format(number); /* $2,500.00 */
        },
        // Table
        filterOnlyCapsText(value, search) {
            return (
                value != null &&
                search != null &&
                typeof value === "string" &&
                value.toString().indexOf(search) !== -1
            );
        },
    },
    computed: {
        ...mapState('permisos', ['permisos']),
        blockBoton() {
            return this.canal != null && this.dates != ["", ""];
        },
        canShow() {
            var canView = false;
            var roles = [];
            this.roles.forEach((element) => {
                roles.push(element.rol);
            });
            const rolesToView = ["ADMIN", "DIRECTOR", "FINANZAS"];
            roles.forEach((element) => {
                if (rolesToView.includes(element)) {
                    canView = true;
                }
            });
            return canView;
        },
        currentRol() {
            let roles = [];
            this.roles.forEach((element) => {
                if (element.rol != null) {
                    roles.push(element.rol);
                }
            });

            if (roles.length > 0) {
                return roles[0];
            } else {
                return "";
            }
        },
    },
};
</script>
